/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { GET_KYCDOC_POLICYID, GET_TRANSACTION_LIST } from "../graphql";
  import { VApplication } from "../../../application";
  import { usePolicyId } from "../provider";
  import { toHeaderCase, toLowerCase } from "js-convert-case";
  import config from "../config/featuresSection.config.json";
  import {useTheme} from "../../../providers/theme";

  import moment from 'moment';

  export interface IGetTransactionListMethods extends IPluginMethodMap {
    getGetTransactionListProps(args: any): Promise<any>;
  }
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  const lookup = require("country-code-lookup");
  
  export class GetTransactionListService implements IAgentPlugin {
    readonly methods: IGetTransactionListMethods;
  
    constructor() {
      this.methods = {
        getGetTransactionListProps: this.getProps.bind(this),
      };
    }
  
      async getProps(args: any) {
        const { policyNumber, userVid } = usePolicyId();
        console.log(`transaction list service::`);
        const kycDocs = await this.getKycDocsByPolicyId({
          policyId: policyNumber,
          vuid: userVid || "",
        });
        console.log(`KYC documents in GET_MY_POLICY_DETAIL`, kycDocs);
    
        const policyIds = kycDocs?.data?.map((doc: any) => doc?._id);
        console.log(`Policy IDs`, policyIds);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
          if (client) {
            const res = await client.query({
              query: GET_TRANSACTION_LIST,
              variables: {
                input: {
                  policyId: policyNumber,
                },
                input1: {
                  limit: 100,
                  where: [
                    {
                      column: "txnOwner",
                      op: "Equal",
                      value: [userVid],
                    },
                    {
                      column: "type",
                      op: "Equal",
                      value: ["POLICY_PURCHASE_FLOW"],
                    },
                    {
                      column: "txnSetId",
                      op: "In",
                      value: [policyNumber, null],
                    },
                  ],
                },
              },
              fetchPolicy: "network-only",
            });
    
            const kycRes = await client.query({
              query: GET_TRANSACTION_LIST,
              variables: {
                input: { policyId: policyNumber },
                input1: {
                  limit: 100,
                  where: [
                    { column: "txnOwner", op: "Equal", value: [userVid] },
                    { column: "type", op: "Equal", value: ["KYC_SUBMISSION"] },
                    { column: "txnSetId", op: "In", value: [policyNumber, null] },
                    { column: "proofId", op: "In", value: policyIds || [] },
                  ],
                },
              },
              fetchPolicy: "network-only",
            });
    
            const bankDetailRes = await client.query({
      query: GET_TRANSACTION_LIST,
      variables: {
        input: { policyId: policyNumber },
        input1: {
          limit: 100,
          where: [
            { column: "performedBy", op: "Equal", value: [userVid] },
            { column: "type", op: "Equal", value: ["BANK_DETAIL"] }, 
            { column: "txnSetId", op: "In", value: [policyNumber, null] },
            { column: "proofId", op: "In", value: policyIds || [] }, 
          ],
        },
      },
      fetchPolicy: "network-only",
    });
    
    
    
            const mergedData = [
              ...(res?.data?.getTxnList?.data || []),
              ...(kycRes?.data?.getTxnList?.data || []),
                ...(bankDetailRes?.data?.getTxnList?.data || []),
            ];
    
            return {
              accordionItems: this.getAccordionItems(mergedData),
              timelineData: {
                ...res?.data?.getTxnList,   
                data: mergedData,           
              },
            };
          }
        } catch (err: any) {
          console.log(`Sign In user error`, err?.response?.data);
          throw Error(err?.response?.data?.error?.display_message);
        }
        // return { ...(config || {}) };
      }
    
      async getKycDocsByPolicyId(args: { policyId: any; vuid: string }) {
        console.log("Kishore");
        const { policyId, vuid } = args;
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
    
        try {
          if (client) {
            const res = await client.query({
              query: GET_KYCDOC_POLICYID,
              variables: {
                policyId: policyId,
                vuid,
              },
              fetchPolicy: "network-only",
            });
    
            console.log(JSON.stringify(res) + "befjj");
    
            if (res?.data?.getKycDocsByPolicyId) {
              return res?.data?.getKycDocsByPolicyId;
            }
            return null;
          }
        } catch (err: any) {
          console.log(`Error fetching KYC documents`, err?.response?.data);
          throw Error(err?.response?.data?.error?.display_message);
        }
      }
    

    private getAccordionItems(txList:any){
        let items:any = [];
        if(txList?.length > 0){
          let timelineDetails = this.getTimeLine(txList);
          items.push({
            type:"timeline",
            title:config?.timelineDetails?.title,
            data:[...timelineDetails],
            lineColor:"#262B40",
            horizontalStepperColors:{
              DONE:"#56DCBA",
              UNDONE:"#56DCBA",
              LAST:"#56DCBA",
              CURRENT:"#56DCBA"
            }
          })
        }
        return items;
      }

      private getTimeLine(data: any) {
        let _temp: any = [];
        Array.isArray(data) && data?.forEach(element => {
            _temp.push(
                {
                    "key": element?.id,
                    "headline": toHeaderCase(element?.action ?? ""),
                    "headlineBackgroundColor": "#579783",
                    "children": this.getChildren(element)
                }
            )
        });
    
        return _temp;
    }
    
    private getChildren(data: any) {
      let _temp: any = [];
      _temp.push({
          "itemId": data?.id,
          multiColList: this.getProvenanceAccordion(data),
          "title": toHeaderCase(data?.action ?? ""),
          "subtitle": data?.when
          ? moment(parseInt(data?.when)).format("LLL")
          : null,
      });
    
      return _temp;
    }
    
    private getProvenanceAccordion(res: any) {
      let _temp: any = [];
      if (res) {
        let _list: any = [];
        let _date: any = [];
        let _location: any = [];
        if (res?.performedBy?.firstName) {
          _list.push({
            title: toHeaderCase("by"),
            subTitle: `${toHeaderCase(res?.performedBy?.firstName)} ${toHeaderCase(res?.performedBy?.lastName)}`,
            icon: config?.orgIcon
          })
        }
        if(res?.location){
          _location.push({
            title: toHeaderCase("at"),
              subTitle: res?.location ?? "-",
              icon: config?.locationIcon
          })
        }
        if (res?.when) {
            _date.push({
              title: toHeaderCase("on"),
              subTitle: res?.when ? moment(parseInt(res?.when)).format("LLL"): "-",
              icon: config?.dateIcon
            })
        }
        _temp = [..._list, ..._location, ..._date]
      }
      return {
        "numberOfColumns": "2",
        data: _temp
      };
    }       
  }